import { render, staticRenderFns } from "./VChatIframe.vue?vue&type=template&id=74c1c270&scoped=true"
import script from "./VChatIframe.vue?vue&type=script&lang=js"
export * from "./VChatIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c1c270",
  null
  
)

export default component.exports